import { createApp } from 'vue';
import mitt from 'mitt';
import ElementPlus from 'element-plus';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import axios from 'axios';

import App from './App.vue';
import router from './router';
import store from './store';
import { i18n } from './i18n';

import '@/assets/styles/main.scss';
import '@/assets/styles/iconfont.scss';
import '@/assets/javascripts/main.js';

const app = createApp(App);
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$EventBus = mitt();
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.use(ElementPlus).use(store).use(router);
app.use(i18n);
app.mount('#app');